import { createMuiTheme } from '@material-ui/core';

export const version = process.env.REACT_APP_VERSION;
export const buildNumber = process.env.REACT_APP_BUILD_NUMBER;
export const apiUrl = process.env.REACT_APP_API_URL;
export const tokenUrl = process.env.REACT_APP_TOKEN_URL;
export const envName = process.env.REACT_APP_ENV_NAME;

export const smallBtnWidth = 1200;

export const snackbar = createMuiTheme({
    overrides: {
        MuiSnackbarContent: {
            root: {
                width: '90%',
                alignItems: 'start'
            },
            action: {
                paddingTop: 5,
                paddingLeft: 0,
                display: 'flow-root'
            },
            message: {
                width: '90%'
            }
        },
        MuiSnackbar: {
            root: {
                alignItems: "start"
            }
        },
        MuiIconButton: {
            root: {
                padding: 0
            }
        }
    }
});


export const newPlannerProject2Layers = { "unit": "cm", "layers": { "layer-1": { "id": "layer-1", "altitude": 0, "order": 0, "opacity": 1, "name": "default", "visible": true, "vertices": {}, "lines": {}, "holes": {}, "areas": {}, "items": {}, "selected": { "vertices": [], "lines": [], "holes": [], "areas": [], "items": [] } }, "layer-2": { "id": "layer-2", "altitude": 0, "order": 0, "opacity": 1, "name": "layer-2", "visible": true, "vertices": {}, "lines": {}, "holes": {}, "areas": {}, "items": {}, "selected": { "vertices": [], "lines": [], "holes": [], "areas": [], "items": [] } }, "layer-3": { "id": "layer-3", "altitude": 0, "order": 0, "opacity": 1, "name": "layer-3", "visible": true, "vertices": {}, "lines": {}, "holes": {}, "areas": {}, "items": {}, "selected": { "vertices": [], "lines": [], "holes": [], "areas": [], "items": [] } } }, "grids": { "h1": { "id": "h1", "type": "horizontal-streak", "properties": { "step": 20, "colors": ["#808080", "#ddd", "#ddd", "#ddd", "#ddd"] } }, "v1": { "id": "v1", "type": "vertical-streak", "properties": { "step": 20, "colors": ["#808080", "#ddd", "#ddd", "#ddd", "#ddd"] } } }, "selectedLayer": "layer-1", "groups": {}, "width": 2000, "height": 1500, "meta": {}, "guides": { "horizontal": {}, "vertical": {}, "circular": {} } }